import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from '../reducers/authReducer';
import { biasReducer } from '../reducers/biasReducer';
import { catalogReducer } from '../reducers/catalogReducer';
import { clientReducer } from '../reducers/clientReducer';
import { filesReducer } from '../reducers/filesReducer';
import { individualAreasReducer } from '../reducers/individualAreasReducer';
import { sidebarReducer } from '../reducers/sidebarReducer';
import { userReducer } from '../reducers/userReducer';
import { newSearcherReducer } from '../reducers/newSearcherReducer';
import { uiReducer } from '../reducers/uiReducer';
import { providerReducer } from '../reducers/providerReducer';

// Combine reducers
const reducer = {
	auth: authReducer,
	user: userReducer,
	catalogs: catalogReducer,
	clients: clientReducer,
	providers: providerReducer,
	ui: uiReducer,
	sidebar: sidebarReducer,
	biases: biasReducer,
	individualAreas: individualAreasReducer,
	files: filesReducer,
	searchConfig: newSearcherReducer,
};

// Set store with reducers and thunk middleware
const store = configureStore({
	reducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});

export default store;
